const routes = {
  all: "*",
  homepage: "/",
  login: "/login",

  dmLogin: "/dm-login",
  dmPortal: "/dm/portal",
  dmReportList: "/dm/report-list",
  dmRestaurantReport: "/dm/restaurant-report",
  dmFTSReport: "/dm/fts-report",
  dmAuditorReport: "/dm/auditor-report",
  dmLabReport: "/dm/lab-report",

  adminLogin: "/admin-login",
  adminPortal: "/admin/portal",
  adminReportList: "/admin/report-list",
  adminRestaurantReport: "/admin/restaurant-report",
  adminFTSReport: "/admin/fts-report",
  adminAuditorReport: "/admin/auditor-report",
  adminLabReport: "/admin/lab-report",
  reports: "/reports",
};

const apiEndpoints = {
  login: "/login",
  logout: "/user/logout",
  media: "/media",
  getLocation: "/get-directions",
  getDMReportList: "/dm/report-list",
  getAdminReportList: "/admin/report-list",
  getTerritoryList: "/admin/territory-list",
  getAdminRestaurantList: "/admin/restaurant-list",
  getDMRestaurantList: "/dm/restaurant-list",
  getAdminUserReport : "/admin/user-report-list",
  getAdminReportUsers: "/admin/user-list",
  getAdminReportRestaurants:"/admin/restaurant-list/"
};

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL

const notAllowHeader = [];

const notAllowFooter = [];

const headerChildPages = [
  routes.adminRestaurantReport,
  routes.adminFTSReport,
  routes.adminAuditorReport,
  routes.adminLabReport,
  routes.dmRestaurantReport,
  routes.dmFTSReport,
  routes.dmAuditorReport,
  routes.dmLabReport,
];

const companyNames = {
  fog: "fog",
};

const companyConfig = {
  fog_test: {
    name: "fog",
    server: "test",
    checkBrowser: true,
    pages: [
      routes.dmPortal,
      routes.adminPortal,
      routes.adminRestaurantReport,
      routes.adminFTSReport,
      routes.adminAuditorReport,
      routes.adminLabReport,
      routes.dmRestaurantReport,
      routes.dmFTSReport,
      routes.dmAuditorReport,
      routes.dmLabReport,
    ],
  },
  fog_copy: {
    name: "fog",
    server: "copy",
    checkBrowser: true,
    pages: [
      routes.dmPortal,
      routes.adminPortal,
      routes.adminRestaurantReport,
      routes.adminFTSReport,
      routes.adminAuditorReport,
      routes.adminLabReport,
      routes.dmRestaurantReport,
      routes.dmFTSReport,
      routes.dmAuditorReport,
      routes.dmLabReport,
    ],
  },
  fog: {
    name: "fog",
    server: "live",
    checkBrowser: true,
    pages: [
      routes.dmPortal,
      routes.adminPortal,
      routes.adminRestaurantReport,
      routes.adminFTSReport,
      routes.adminAuditorReport,
      routes.adminLabReport,
      routes.dmRestaurantReport,
      routes.dmFTSReport,
      routes.dmAuditorReport,
      routes.dmLabReport,
    ],
  },
};

export {
  routes,
  IMAGE_URL,
  apiEndpoints,
  notAllowHeader,
  notAllowFooter,
  companyNames,
  companyConfig,
  headerChildPages,
};
